import { render, staticRenderFns } from "./JumpsellerIntegrationConfig.vue?vue&type=template&id=64eebf2a&lang=pug"
import script from "./JumpsellerIntegrationConfig.vue?vue&type=script&lang=js"
export * from "./JumpsellerIntegrationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports